import styled from 'styled-components'

export const EmptyWrapper = styled.span`
  transform: scale(0.75);
`
